import { Card, CardContent, Typography, WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';

const styles = (theme: Theme) =>
	createStyles({
		button: {
			height: '40px',
			width: '200px',
		},
		buttonContent: {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'center',
			marginTop: '10px',
		},
		card: {
			height: 'auto',
			margin: '10px 20px 0px 20px',
			width: '240px',
		},
		card2: {
			height: 'auto',
			margin: '10px 20px 0px 20px',
			width: '270px',
		},
		content: {
			padding: '8px 8px 10px 8px',
		},
		image: {
			width: '200px',
		},
		imageContent: {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'center',
			padding: '10px 10px 0px 10px',
		},
		text: {
			height: '280px',
			padding: '10px 10px 0px 10px',
		},
		text2: {
			height: '150px',
			padding: '10px',
		},
		text2ForIE: {
			fontSize: '90%',
			height: '150px',
			lineHeight: '1.3',
			padding: '10px',
		},
		textForIE: {
			fontSize: '90%',
			height: '280px',
			lineHeight: '1.3',
			padding: '10px 10px 0px 10px',
		},
		title: {
			fontWeight: 'bold',
			height: '30px',
			textAlign: 'center',
		},
	});

interface IQuickCardProps {
	title?: string;
	ImageSrc: string;
	text: string;
	buttonName: string;
	buttonDisabled?: boolean;
	onClick?: () => any;
}
interface IProps extends WithStyles<typeof styles>, IQuickCardProps {}

const QuickModeCard: React.FunctionComponent<IProps> = props => {
	const {
		classes,
		title,
		ImageSrc,
		text,
		buttonName,
		buttonDisabled,
		onClick,
	} = props;

	let textStyle = title ? classes.text : classes.text2;
	const userAgent = window.navigator.userAgent.toLowerCase();
	if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1) {
		textStyle = title ? classes.textForIE : classes.text2ForIE;
	}
	return (
		<Card className={title ? classes.card2 : classes.card}>
			<CardContent className={classes.content}>
				{title && (
					<Typography
						variant="h6"
						color="primary"
						className={classes.title}
					>
						{title}
					</Typography>
				)}
				<Typography component="p" className={classes.imageContent}>
					<img src={ImageSrc} className={classes.image} />
				</Typography>
				<Typography className={textStyle} component="p">
					<span
						dangerouslySetInnerHTML={{
							__html: text,
						}}
					/>
				</Typography>
				<Typography
					variant="button"
					display="block"
					className={classes.buttonContent}
				>
					<Button
						variant="contained"
						color="primary"
						className={classes.button}
						disabled={buttonDisabled}
						onClick={onClick}
					>
						{buttonName}
					</Button>
				</Typography>
			</CardContent>
		</Card>
	);
};

export default withStyles(styles)(QuickModeCard) as React.ComponentType<
	IQuickCardProps
>;



// WEBPACK FOOTER //
// ./src/components/QuickModeCard.tsx